export enum DataIntegrityValidationErrorResolutionStatusEnum {
    None = 0,
    Unresolved = 1,
    AutomaticallyResolved = 2,
    ManuallyResolved = 3,
    Relapsed = 4,
    InProgress = 5,
}
